import { Capacitor } from '@capacitor/core'
import { useStore } from 'effector-react'
import ym from 'react-yandex-metrika'
import { YANDEX_METRIKA_ACCOUNT } from '~/shared/config/env'
import { featureFlagModel } from '~/shared/lib/featureFlag'
const platform = Capacitor.getPlatform()

export enum YM_KEYS_ENUM {
  button_go_to_register = 'button_go_to_register',
  booking_cars_list_view_auth = 'booking_cars_list_view_auth',
  booking_cars_list_view_un_auth = 'booking_cars_list_view_un_auth',
  booking_car_card_view_auth = 'booking_car_card_view_auth',
  booking_car_card_view_un_auth = 'booking_car_card_view_un_auth',
}

export const useEvents = () => {
  const featureFlags = useStore(featureFlagModel.$featureFlags)
  const isActive = featureFlags.yandex_metrika && YANDEX_METRIKA_ACCOUNT

  const ymEvent = (key: string) => {
    if (!isActive) return

    ym?.('reachGoal', key, { platform })
  }

  return { ymEvent }
}
